import React from 'react';
import PropTypes from 'prop-types';

import CallParticipant from 'components/phone_controls/participants/call_participant';
import connect from 'components/lib/connect';

export const AgentParticipant = ({ agentParticipant, agentName }) => (
  <CallParticipant
    key={agentParticipant.participantId}
    displayName={agentName}
    participantId={agentParticipant.participantId}
    participantStatus={agentParticipant.status}
    showMenuOnHover
  />
);

AgentParticipant.propTypes = {
  agentName: PropTypes.string,
  agentParticipant: PropTypes.shape({
    callId: PropTypes.string,
    participantId: PropTypes.string,
    status: PropTypes.string,
  }),
};

function mapStateToProps({ getProvider }, { agentId }) {
  let activeCall = getProvider('activeCall').get();
  let agent = getProvider('agents').findBy({ id: agentId });
  let agentName = agent.name || agent.email;
  return {
    agentName,
    agentParticipant: activeCall.conversationItem.content.findParticipantById(agentId),
  };
}

export default connect(mapStateToProps, null)(AgentParticipant);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/phone_controls/participants/agent_participant.jsx